import React from 'react'
import { Link } from 'react-router-dom'

const ItemDetail = ({ item, component: Component, onChannelSelected, preloadDetail, clearPreLoadDetail }) => {
  switch (item.type) {
    case "webview":
    case "stream":
      return (<div onClick={() => onChannelSelected(item)}>
        <Component item={item} />
      </div>)
    case "featured":
      return (
        <Link
          onMouseEnter={preloadDetail && preloadDetail(item)}
          onMouseLeave={clearPreLoadDetail}
          key={item.id}
          to={`/playlists/${item.id}`}
        >
          <Component item={item} />
        </Link>
      )
    default:
      return (
        <Link
          onMouseEnter={preloadDetail && preloadDetail(item)}
          onMouseLeave={clearPreLoadDetail}
          key={item.id}
          to={`/${item.type}/${item.id}`}
        >
          <Component item={item} />
        </Link>
      )
  }
}

export default ItemDetail